import { AxiosInstance } from "axios";
import { apiTypeUrlBaseGet } from "../api_common";
import { API_APP_NAMES, API_TYPES } from "../api_constants";
import { authorizationObDefault, axiosInstanceCreate } from "./axios_common";
import { axiosInstance401Handle } from "./axios_intercepter_common";

const unosUrlBase: string = apiTypeUrlBaseGet(API_TYPES.UNOS);

const unosAuth = authorizationObDefault();

const API_UNOS_RETRY_LIMIT: number = 3;

export const axiosUnos: AxiosInstance = axiosInstanceCreate(unosUrlBase);

axiosUnos.interceptors.response.use(null, async (err) => {
  if (typeof err.config.retryLimit === "undefined") {
    err.config.retryLimit = API_UNOS_RETRY_LIMIT;
  }
  if (err.config.retryLimit === 0) {
    throw err;
  }
  err.config.retryLimit--;
  if (err.response.status === 401 && err.config.retryLimit > 0) {
    try {
      await axiosInstance401Handle(axiosUnos, API_APP_NAMES.UNOS, unosAuth);
    } catch (err) {
      throw err;
    }
  }
  const response = await axiosUnos(err.config);
  return response;
});
